import React, { type ReactNode } from "react";
import "./NoticeMessage.scss";

interface NoticeMessageProps {
  content?: ReactNode;
  className?: string;
}

const NoticeMessage: React.FC<NoticeMessageProps> = ({
  content = null,
  className = "",
}) => {
  return (
    <div className={`notice-message${className ? ` ${className}` : ""}`}>
      {content}
    </div>
  );
};

export default NoticeMessage;
